import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';

import PriorParamsHomogeneousLognormal from '../Params/PriorParamsHomogeneousLognormal';
import PriorParamsHomogeneousNormal from '../Params/PriorParamsHomogeneousNormal';
import FullWidthFormControl from '../../../FormFields/FullWidthFormControl';

class PriorDistHomogeneous extends React.Component {
  getPriorParamsTypesOptions = (val) => {
    const { onRemoveLikelihoodParamsComponentResult, disable } = this.props;
    switch (val) {
      case 'Log-Normal': return (
        <PriorParamsHomogeneousLognormal
          selected={{
            prior: {
              params_type: this.props.selected.prior.params_type,
              params: this.props.selected.prior.params,
            },
            likelihood: {
              ...this.props.selected.likelihood,
            },
          }}
          onUpdatePriorParamsType={this.props.onUpdatePriorParamsType}
          onUpdatePriorParamsValues={this.props.onUpdatePriorParamsValues}
          onUpdatePriorParamsComponentResult={this.props.onUpdatePriorParamsComponentResult}
          onUpdateLikelihoodDist={this.props.onUpdateLikelihoodDist}
          onUpdateLikelihoodParamsType={this.props.onUpdateLikelihoodParamsType}
          onAddLikelihoodParamsValues={this.props.onAddLikelihoodParamsValues}
          onAddLikelihoodParamsList={this.props.onAddLikelihoodParamsList}
          onRemoveLikelihoodParamsValues={this.props.onRemoveLikelihoodParamsValues}
          onUpdateLikelihoodParamsValues={this.props.onUpdateLikelihoodParamsValues}
          onAddLikelihoodParamsComponentResult={this.props.onAddLikelihoodParamsComponentResult}
          onRemoveLikelihoodParamsComponentResult={onRemoveLikelihoodParamsComponentResult}
          disable={disable}
        />
      );
      default:
      case 'Normal': return (
        <PriorParamsHomogeneousNormal
          selected={{
            prior: {
              params_type: this.props.selected.prior.params_type,
              params: this.props.selected.prior.params,
            },
            likelihood: {
              ...this.props.selected.likelihood,
            }
          }}
          onUpdatePriorParamsType={this.props.onUpdatePriorParamsType}
          onUpdatePriorParamsValues={this.props.onUpdatePriorParamsValues}
          onUpdatePriorParamsComponentResult={this.props.onUpdatePriorParamsComponentResult}
          onUpdateLikelihoodDist={this.props.onUpdateLikelihoodDist}
          onUpdateLikelihoodParamsType={this.props.onUpdateLikelihoodParamsType}
          onAddLikelihoodParamsValues={this.props.onAddLikelihoodParamsValues}
          onAddLikelihoodParamsList={this.props.onAddLikelihoodParamsList}
          onRemoveLikelihoodParamsValues={this.props.onRemoveLikelihoodParamsValues}
          onUpdateLikelihoodParamsValues={this.props.onUpdateLikelihoodParamsValues}
          onAddLikelihoodParamsComponentResult={this.props.onAddLikelihoodParamsComponentResult}
          onRemoveLikelihoodParamsComponentResult={onRemoveLikelihoodParamsComponentResult}
          disable={disable}
        />);
    }
  };

  getView = () => {
    const { disable } = this.props;
    return (
      <FullWidthFormControl>
        <InputLabel shrink htmlFor="prior_dist_homo-helper">Prior Type</InputLabel>
        <Select
          value={this.props.selected.prior.dist}
          onChange={e => this.props.onUpdatePriorDist(e, e.target.value)}
          input={<Input name="prior_dist_homo" id="prior_dist_homo-helper" />}
          disabled={disable && disable.prior_type}
        >
          <MenuItem value="Log-Normal">Log-Normal</MenuItem>
          <MenuItem value="Normal">Normal</MenuItem>
        </Select>
      </FullWidthFormControl>
    );
  };

  render() {
    return (
      <div>
        {this.getView()}
        {this.getPriorParamsTypesOptions(this.props.selected.prior.dist)}
      </div>
    );
  }
}

PriorDistHomogeneous.propTypes = {
  onUpdatePriorDist: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorParamsType: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorParamsValues: PropTypes.instanceOf(Function).isRequired,
  onUpdatePriorParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodDist: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodParamsType: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsList: PropTypes.instanceOf(Function).isRequired,
  onRemoveLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onUpdateLikelihoodParamsValues: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  onRemoveLikelihoodParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  selected: PropTypes.shape({
    likelihood: PropTypes.shape({
      dist: PropTypes.string,
      params_type: PropTypes.string,
      params: PropTypes.shape({
        component_result: PropTypes.arrayOf(Number).isRequired,
        values: PropTypes.arrayOf(PropTypes.arrayOf(Number)).isRequired,
      }).isRequired,
    }).isRequired,
    prior: PropTypes.shape({
      dist: PropTypes.string,
      params_type: PropTypes.string,
      params: PropTypes.shape({
        component_result: PropTypes.number,
        values: PropTypes.arrayOf(Number).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default PriorDistHomogeneous;
